export const TEAM_PERIODS = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: 'all', label: 'All time' },
] as const;

export type TeamPeriod = (typeof TEAM_PERIODS)[number]['value'];

export function parseTeamPeriod(raw: string | null | undefined): TeamPeriod {
  if (raw === '7d' || raw === '30d' || raw === '90d' || raw === 'all') return raw;
  return '30d';
}

export function formatPracticeDuration(seconds: number): string {
  if (seconds <= 0) return '—';
  if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
  return `${(Math.round((seconds / 3600) * 10) / 10).toFixed(1)}h`;
}

export function formatGoalScore(score: number | null | undefined): string {
  return score == null ? '—' : score.toFixed(1);
}

export function formatReachRate(rate: number | null | undefined): string {
  return rate == null ? '—' : `${Math.round(rate * 100)}%`;
}

export function memberReachRate(goalReachedCount: number, sessionCount: number): number | null {
  if (sessionCount <= 0) return null;
  return goalReachedCount / sessionCount;
}
